import jwt_decode from "jwt-decode";
import { accessToken } from "../../redux/auth/authReduccer";
// let accessToken = localStorage.getItem('JWT_access_token')

export const decodeToken = () => {return jwt_decode(accessToken())}
export const userId = () => { return decodeToken().user_id ;}
